import { useQuery } from "@apollo/client";
import {
  GET_MY_IN_PROGRESS_CHALLENGES,
  GET_MY_COMPLETED_CHALLENGES,
} from "../api/my-challenges";

export const useMyInProgressChallenges = () => {
  const { data, loading, error, refetch } = useQuery(
    GET_MY_IN_PROGRESS_CHALLENGES,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  return {
    challenges: data?.myInProgressChallenges || [],
    loading,
    error,
    refetch,
  };
};

export const useMyCompletedChallenges = () => {
  const { data, loading, error, refetch } = useQuery(
    GET_MY_COMPLETED_CHALLENGES,
    {
      fetchPolicy: "cache-and-network",
    }
  );

  return {
    challenges: data?.myCompletedChallenges || [],
    loading,
    error,
    refetch,
  };
};
